import { Mobile as Mobile_phosphor } from './Mobile.phosphor';
import { Mobile as Mobile_zoomg } from './Mobile.zoomg';
import { Mobile as Mobile_zoomit } from './Mobile.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Mobile_zoomg;

    case 'phosphor':
      return Mobile_phosphor;

    default:
      return Mobile_zoomit;
  }
};

export const Mobile = IconRenderer();
